// extracted by mini-css-extract-plugin
export default {"main-container":"PhoneVerify_main-container__UaY8z","next-button":"PhoneVerify_next-button__8Rvuf","loading":"PhoneVerify_loading__KdPip"};